module.exports = __webpack_public_path__ + "img/WCU_Main-dark.1d6fdb79.png";